























































































import {
  computed,
  defineComponent,
  onMounted,
  Ref,
  ref,
} from '@vue/composition-api';
import PrettyCheck from 'pretty-checkbox-vue/check';

import generateColorPalette from '@/generateColorPalette';
import useAxios from '@/useAxios';
import {
  deleteFileConfig,
  getConfigs,
  updateWebsiteConfig,
} from '@/api/index';

import ThemeColorsInput from '@/components/ThemeColorsInput.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonDropzoneWithAxios from '@/components/Dropzone/CommonDropzoneWithAxios.vue';
import PanelWithMetaConfigEditor from '@/components/Config/PanelWithMetaConfigEditor.vue';

const Website = defineComponent({
  components: {
    PrettyCheck,
    ThemeColorsInput,
    CommonModalWithPreset,
    CommonDropzoneWithAxios,
    PanelWithMetaConfigEditor,
  },
  setup() {
    const { axios } = useAxios();
    const successModal = ref(null);
    const features: Ref<any> = ref({});
    const textConfigs: Ref<any> = ref({});
    const images: Ref<any> = ref({});
    const selectedColors: Ref<{ key: string; colorCode: string }[]> = ref([
      { key: 'primary', colorCode: '#174681' },
      { key: 'secondary', colorCode: '#3fc476' },
    ]);

    const computedTextConfigsInput = computed(() => {
      const result = {};
      Object.entries(textConfigs.value).forEach(([key, value]: any[]) => {
        (result as any)[key] = value.value;
      });
      return result;
    });
    const computedFeatureInput = computed(() => {
      const result = {};
      Object.entries(features.value).forEach(([key, value]: any[]) => {
        (result as any)[key] = value.value;
      });
      return result;
    });

    async function callUpdateWebsiteConfig(data: any) {
      const result = await updateWebsiteConfig(data, 'website');
      if (result !== '') {
        features.value = (result as any).features as any;
        textConfigs.value = (result as any).textConfigs as any;
        images.value = (result as any).images as any;
        (successModal.value as any).compose({ action: 'แก้ไข', entity: 'การตั้งค่า เรียบร้อย' });
      }
    }
    async function submitTextConfigs() {
      await callUpdateWebsiteConfig(computedTextConfigsInput.value);
    }
    async function submitUpdateConfig() {
      await callUpdateWebsiteConfig(computedFeatureInput.value);
    }

    async function updateConfig(name: string, status: boolean) {
      (features.value as any)[name].value = !status;
    }

    const loading = ref(false);
    async function callGetConfigs(force = false) {
      loading.value = true;
      const res = await getConfigs('website', force);
      const colors = await getConfigs('color');
      features.value = (res as any).features as any;
      textConfigs.value = (res as any).textConfigs as any;
      images.value = (res as any).images as any;
      selectedColors.value = colors;
      loading.value = false;
    }
    onMounted(async () => {
      await callGetConfigs();
    });

    async function uploadDone() {
      await callGetConfigs();
    }
    const deleteConfigImageModal = ref(null);
    async function deleteConfigImageAction(ctx: { key: string }) {
      await deleteFileConfig(ctx.key, 'website');
      await callGetConfigs();
    }
    const openDeleteConfigImageModal = (key: string) => {
      (deleteConfigImageModal.value as any).compose({ key, action: 'ลบ', entity: 'รูปภาพ' });
    };

    // ========================================= //
    // ======= USE WITH COLOR INPUT ============ //
    // =======VVVVVVVVVVVVVVVVVVVVVV============ //
    const allowToSaveColor = ref(false);
    const computedColorsInput = computed(() => {
      const colors = [
        { ...selectedColors.value.find((c: { key: string; colorCode: string }) => c.key === 'primary') },
        { ...selectedColors.value.find((c: { key: string; colorCode: string }) => c.key === 'secondary') },
      ];

      function buildPalette(name: string, color500: string) {
        const colorResult: any = {};
        const palette = generateColorPalette(color500);
        colorResult[name] = color500;
        Object.entries(palette.colors).forEach(([key, val]) => {
          colorResult[`${name}-${key}`] = val;
        });
        return colorResult;
      }

      const primary = (colors as { key: string; colorCode: string }[]).find((c) => c.key === 'primary');
      const secondary = (colors as { key: string; colorCode: string }[]).find((c) => c.key === 'secondary');

      return {
        primary: buildPalette('color-primary', (primary) ? primary.colorCode : '#00D190'),
        secondary: buildPalette('color-secondary', (secondary) ? secondary.colorCode : '#1F60C6'),
      };
    });
    async function submitUpdateColor() {
      await callUpdateWebsiteConfig({
        ...computedColorsInput.value.primary,
        ...computedColorsInput.value.secondary,
      });
    }

    return {
      successModal,
      loading,
      axios,
      selectedColors,

      features,
      textConfigs,
      images,

      uploadDone,

      updateConfig,
      computedFeatureInput,

      submitTextConfigs,
      submitUpdateConfig,
      submitUpdateColor,

      deleteConfigImageModal,
      deleteConfigImageAction,
      openDeleteConfigImageModal,

      allowToSaveColor,
    };
  },
});

export default Website;
